import React from 'react';
import './AboutSection.css';
import { useNavigate } from 'react-router-dom';
// import { IMAGES } from '../../assets/image';
import { CREDIT_UNION } from '../../assets/constants';

const AboutSection = () => {

  const navigate = useNavigate();
    const handleApplyNow = () => {
    localStorage.removeItem('current_guid');
    localStorage.removeItem('form_data');
    sessionStorage.clear();
    navigate('/ApplicationForm');
  };

  return (
    <section className="about-section" aria-labelledby="about-heading">
      <div className="layout-container">
        <h2 id="about-heading" className="about-heading">
          About {CREDIT_UNION.INFO.NAME}
        </h2>
        <p className="about-text" dangerouslySetInnerHTML={{ __html: CREDIT_UNION.ABOUT.TEXT }}>
          {/* {CREDIT_UNION.ABOUT.TEXT} */}
        </p>

        {/* <div className="about-btn-wrapper">
          <a
            href="/ApplicationForm"
            className="about-btn"
            role="button"
            aria-label="Apply now for refinancing"
          >
            APPLY NOW
          </a> */}

          <div className="about-btn-wrapper">
            <button className="about-btn" onClick={handleApplyNow} aria-label="Start your application now" >APPLY NOW </button>
          </div>
        {/* </div> */}
      </div>
    </section>
  );
};

export default AboutSection;
